import React, { useEffect, useState, useRef } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { StyledForm } from "../../styled-components/StyledForm.style";
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import api from '../../services/api';
import Swal from "sweetalert2";

export const ModalCancelamentoTS = ({
    isOpen,
    onAfterOpen,
    onRequestClose,
    idTimesheet,
    loadPage
}) => {
    const [descricaoAtividade, setDescricaoAtividade] = useState("");
    var [loading, setLoading] = useState(false);

    const handleDescricaoAtividade = (descricao) => {
        setDescricaoAtividade(descricao);
    };

    const formActivies = async () => {
        if (descricaoAtividade == "") {
            Swal.fire({
                title: "Atenção",
                text: "É necessário informar o motivo do cancelamento!",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        }

        setLoading(true)
        var payload = {
            idTimesheet: idTimesheet,
            mensagem: descricaoAtividade
        }
        try {
            await api.post(`Timesheet/cancelar`, payload);
            await loadPage()
            setDescricaoAtividade("")
            setLoading(false)
            onRequestClose(false);
        } catch (err) {
            setLoading(false)
        }
    }

    useEffect(() => {
        setDescricaoAtividade("")
    }, [idTimesheet]);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '30%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%',
            // maxWidth: '50%'
        },
        overlay: {
            zIndex: 9999
        }
    };


    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Novo grupo de atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <StyledForm>
                <StyledTablePage>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Cancelamento do Timesheet</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex.Item style={{ marginTop: '7px' }}>
                        Motivo do cancelamento:
                    </Flex.Item>
                    <Flex>
                        <Flex.Item style={{ width: '100%' }}>
                            <textarea
                                rows="2"
                                className="input-form-list"
                                style={{ width: '100%' }}
                                name="Motivo"
                                placeholder="Motivo"
                                key={descricaoAtividade}
                                defaultValue={descricaoAtividade}
                                onBlur={(event) => handleDescricaoAtividade(event.target.value)} />
                        </Flex.Item>
                    </Flex>
                    <Flex style={{ textAlign: "right" }}>
                        <Flex.Item style={{ width: '100%' }}>
                            {
                                loading ?
                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                    : <input className='default-button-red' value='Cancelar' type="button" onClick={formActivies} />
                            }
                        </Flex.Item>
                    </Flex>
                </StyledTablePage>
            </StyledForm>
        </Modal>
    );
};
